import * as React from 'react';
import { useParams, useLocation } from 'react-router-dom';

// Shim that supplies a v5-style `match` prop to legacy class components.
// Old code did `this.props.match.params.id` and consumed `params.url`.
export interface LegacyMatch<TParams = { [k: string]: string | undefined }> {
	params: TParams;
	url: string;
	path: string;
	isExact: boolean;
}

export function withMatch<P extends { match: LegacyMatch<any> }>(
	Wrapped: React.ComponentType<P>
): React.FC<Omit<P, 'match'>> {
	const Bridge: React.FC<Omit<P, 'match'>> = (props) => {
		const params = useParams();
		const location = useLocation();
		const match: LegacyMatch = {
			params,
			url: location.pathname,
			path: location.pathname,
			isExact: true
		};
		// Cast through unknown — TS can't see the shape merge across the Omit.
		return <Wrapped {...(props as unknown as P)} match={match} />;
	};
	Bridge.displayName = `withMatch(${Wrapped.displayName || Wrapped.name || 'Component'})`;
	return Bridge;
}
